import * as Yup from 'yup';

export default Yup.object().shape({
  name: Yup.string().required('Campo obrigatório'),
  barCode: Yup.string().required('Campo obrigatório'),
  value: Yup.number().min(0.01, 'Inválido').required('Campo obrigatório'),
  cost: Yup.number().min(0, 'Custo não pode ser negativo').nullable(),
});

